import * as THREE from "three";
import { CATEGORIES, CATEGORY_META } from "./categories.js";

const projected = new THREE.Vector3();

export function createLabelLayer(root) {
  const pool = [];
  const POOL = 90;
  for (let i = 0; i < POOL; i += 1) {
    const el = document.createElement("button");
    el.type = "button";
    el.className = "word-label";
    el.hidden = true;
    root.appendChild(el);
    pool.push(el);
  }

  function render(items, width, height, selected, onPick) {
    for (let i = 0; i < pool.length; i += 1) {
      const el = pool[i];
      const item = items[i];
      if (!item) {
        el.hidden = true;
        el.onclick = null;
        continue;
      }
      const sx = (item.ndcX * 0.5 + 0.5) * width;
      const sy = (-item.ndcY * 0.5 + 0.5) * height;
      el.hidden = false;
      el.textContent = item.word;
      el.style.transform = `translate(${sx}px, ${sy}px) translate(-50%, -120%)`;
      el.classList.toggle("is-selected", item.index === selected);
      const opacity = item.dist < 18 ? 1 : Math.max(0.28, 1 - (item.dist - 18) / 30);
      el.style.opacity = String(opacity);
      const idx = item.index;
      el.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onPick(idx);
      };
    }
  }

  function clear() {
    for (const el of pool) {
      el.hidden = true;
      el.onclick = null;
    }
  }

  return { render, clear };
}

export function createClusterLabels(root) {
  const nodes = {};
  for (const key of CATEGORIES) {
    const el = document.createElement("button");
    el.type = "button";
    el.className = "cluster-label";
    el.hidden = true;
    el.dataset.category = key;
    root.appendChild(el);
    nodes[key] = el;
  }

  function render(centers, camera, width, height, activeSet, colorMap, onFocus) {
    const showAll = !activeSet || activeSet.size === 0 || activeSet.size === CATEGORIES.length;
    for (const key of CATEGORIES) {
      const el = nodes[key];
      if (!showAll && !activeSet.has(key)) {
        el.hidden = true;
        el.onclick = null;
        continue;
      }
      const c = centers[key];
      projected.set(c.x, c.y, c.z).project(camera);
      if (projected.z < -1 || projected.z > 1 || projected.x < -1.2 || projected.x > 1.2 || projected.y < -1.2 || projected.y > 1.2) {
        el.hidden = true;
        continue;
      }
      const sx = (projected.x * 0.5 + 0.5) * width;
      const sy = (-projected.y * 0.5 + 0.5) * height;
      el.hidden = false;
      el.textContent = CATEGORY_META[key].label;
      el.style.transform = `translate(${sx}px, ${sy}px) translate(-50%, -50%)`;
      el.style.borderColor = colorMap[key];
      el.style.color = colorMap[key];
      el.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onFocus(key);
      };
    }
  }

  function clear() {
    for (const key of CATEGORIES) {
      nodes[key].hidden = true;
      nodes[key].onclick = null;
    }
  }

  return { render, clear };
}
